module.exports = __webpack_public_path__ + "static/media/news__tournaments.1c86da95.jpg";